/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Change_AvatarInputs */



/**
* | output |
* | --- |
* | "Change avatar" |
*
* @param {User_Change_AvatarInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_change_avatar = /** @type {((inputs?: User_Change_AvatarInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Change_AvatarInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Changer l'avatar")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar avatar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar avatar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia avatar")
	return /** @type {LocalizedString} */ ("Change avatar")
});